/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface BootstrapControllerBootstrap200ResponseData { 
    /**
     * Contenido ofuscado (base64). Al deshacerlo: { clientId, firebase }. La ofuscación no es cifrado: evita la lectura casual, nada más.
     */
    payload?: string;
}

